import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { DriverGroup, driverGroupSchema } from '../schemas/driver-group.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Creates Driver Groups
 * @param driverGroups The Driver Groups being created
 * @returns Data Object containing the created Driver Groups
 */
export function postDriverGroups(
  this: unknown,
  driverGroups: Partial<DriverGroup>[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driverGroupsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(driverGroups),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(driverGroupSchema),
      })
    )
  );
}
